import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * PageHead — заголовок страницы (`.page-head` макета): заголовок, необязательный подзаголовок
 * и слот действий справа. Типографика/отступы из токенов.
 */
export interface PageHeadProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}

export const PageHead = forwardRef<HTMLDivElement, PageHeadProps>(
  ({ className, title, subtitle, actions, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('mb-5 flex items-center justify-between gap-3', className)}
      {...props}
    >
      <div className="min-w-0">
        <h1 className="text-20 font-semibold text-txt">{title}</h1>
        {subtitle ? <p className="mt-1 text-txt-secondary">{subtitle}</p> : null}
      </div>
      {actions ? <div className="ml-auto flex max-w-full shrink-0 items-center gap-2.5">{actions}</div> : null}
    </div>
  ),
)
PageHead.displayName = 'PageHead'
